export default {
  contacts: `profile/contact`,
  remove: `profile/contact/remove`,
};
